export default {
  status: 'Status',
  wonoloerStatus: 'Wonoloer Status',
  showFavoriteWonoloers: 'Show Favorite Wonoloers',
  hideFavoriteWonoloers: 'Hide Favorite Wonoloers',
  category: 'Category',
  requestor: 'User',
  search: 'Search',
  venue: 'Location',
  common: {
    all: 'All',
    clear: 'Clear All Filters'
  },
  templates: {
    requestor: 'All Users',
    nullOption: 'All Users'
  },
  filterBar: {
    sort: {
      title: 'Sort',
      new: 'Newest',
      old: 'Oldest'
    },
    headers: {
      sort: 'Sort By',
      filter: 'Filter By'
    }
  }
};
